import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { menuSetActive } from 'actions';

class Menu extends Component {
	constructor(props) {
		super(props);
		this.bodyInner = React.createRef();
	}
	onMouseEnter = (e) => {
		if ( this.props.mode === "wide" ) {
			const target = (this.props.items)? this.props.slug : null;
			this.props.onMenuSelect( target );
		}
	}
	onTouchStart = (e) => {
		if ( this.props.mode === "wide" ) {
			const target = (this.props.open)? null : this.props.slug;
			this.props.onMenuSelect(target);
		}
	}
	onClick = (e) => {
		if ( this.props.mode === "narrow" ) {
			const target = (this.props.open)? null : this.props.slug;
			this.props.onMenuSelect(target);
		}
	}
	render() {
		const {slug, title, items, open} = this.props;
		let classes = ["Menu"];
		classes.push( (items)? "has-descendant" : "no-descendant" );
		classes.push( (open)? "is-open" : "is-closed" );
		const menuBodyStyle = (open)? {} : { display: 'none' };

		let titleNode, bodyNode;
		if ( items ) {
			titleNode = title;
			bodyNode = <MenuList levels={[slug]} title={title} items={items} />;
		} else {
			titleNode = <MenuLink slug={slug} title={title} />
			bodyNode = null;
		}

		return (
			<div id={'Menu_' + slug} className={classes.join(' ')}>
				<span className="Menu-title" 
					onMouseEnter={this.onMouseEnter}
					onTouchStart={this.onTouchStart}
					onClick={this.onClick}>
					{titleNode}
				</span>
				<div className="Menu-body" style={menuBodyStyle}>
					{bodyNode}
				</div>
			</div>
		)
	}
}
Menu.propTypes = {
	slug: PropTypes.string,
	title: PropTypes.string,
	items: PropTypes.array,
	open: PropTypes.bool,
	mode: PropTypes.string,
	onMenuSelect: PropTypes.func
}
const menuMapDispatchToProps = (dispatch) => ({
	onMenuSelect: (slug) => { dispatch( menuSetActive(slug) ) }
})
export default connect(null, menuMapDispatchToProps)(Menu);



const MenuList = ({ levels, title, items }) => {
	if ( !items ) return null;
	const listItems = items.map( (data, index) => {
		return <li key={index}><MenuLink levels={levels} slug={data.slug} title={data.title} /></li>;
	} );
	return <ul className="MenuList">{listItems}</ul>;
}

class MenuLink extends Component {
	constructor(props) {
		super(props);
		this.state = { hover: false };
	}
	onMouseEnter = () => {
		this.setState({ hover: true });
	}
	onMouseLeave = () => {
		this.setState({ hover: false });
	}
	render() {
		const { levels, slug, title } = this.props;
		const segments = (levels)? levels.slice().concat(slug) : [slug];
		const path = '/' + segments.join('/');
		let classes = ['MenuLink'];
		if (this.state.hover) classes.push('hover');

		return (
			<NavLink 
				to={path} 
				className={classes.join(' ')} 
				onMouseEnter={this.onMouseEnter} 
				onMouseLeave={this.onMouseLeave}>
				{title}
			</NavLink>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Header/Nav/Menu.jsx